import { SxProps, Theme } from '@mui/material';

const styles: SxProps<Theme> = {
  width: '100%',
  height: '100%',
};

export default styles;
